// extracted by mini-css-extract-plugin
export default {"wrap":"NotFoundPage_wrap__Jm3iI"};